export default __webpack_public_path__ + "static/media/cow.1aedada2.svg";